import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { DxDataGridComponent, DxTemplateDirective } from 'devextreme-angular';
import {
  DxiColumnComponent,
  DxiValidationRuleComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
import { firstValueFrom } from 'rxjs';
import { CategorieArticoli } from 'src/app/models/categorieArticoli';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { PopupProprietaTipologiaComponent } from 'src/app/shared/components/popups/popup-proprieta-tipologia/popup-proprieta-tipologia.component';
import { CategorieArticoliService } from 'src/app/shared/services/categorie-articoli.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';

@Component({
  selector: 'app-tipi-articoli',
  templateUrl: './tipi-articoli.component.html',
  imports: [
    DxDataGridComponent,
    DxTemplateDirective,
    PopupProprietaTipologiaComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxiColumnComponent,
    DxiValidationRuleComponent,
    DxoLookupComponent,
    DxoExportComponent
  ],
  standalone: true,
})
export class TipiArticoliComponent extends GestArticoliBaseComponent {
  private tipiArticoliS = inject(TipiArticoliService);
  private categorieArticoliS = inject(CategorieArticoliService);

  dataSource: any;
  listCatArticoli: CategorieArticoli[] =[];
  gestMatricola: boolean;
  tipologiaSelezionata: TipiArticoli | null = null;
  popupProprietaTipologiaVisible = false;

  constructor() {
    super();

    //Categoria - assegno la categoria a seconda del modulo attivo
    this.gestMatricola = this.isModVisible('Matricole');

    //this.categorieArticoliS.list().subscribe((dati) => {this.listCatArticoli = dati.sort((a, b) => (a.descrizione < b.descrizione) ? -1 : 1); });
    this.categorieArticoliS.listTemp().subscribe({
      next: (dati) => {
        this.listCatArticoli = dati.sort((a, b) =>
          a.descrizione < b.descrizione ? -1 : 1,
        );
      }
    });

    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(this.tipiArticoliS.list())
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      insert: (values) => {
        return firstValueFrom(this.tipiArticoliS.post(values))
          .then(() => {
            this.tipiArticoliS.getListTipiArticoliTemp(true).subscribe();
            return values;
          })
          .catch(() => {
            throw 'Insertion failed';
          });
      },
      remove: (values) => {
        console.log(values);
        return (
          firstValueFrom(this.tipiArticoliS.remove(values))
            //.catch(() => { throw 'Deletion failed' });
            .then(() => {
              console.log('delete eseguito');
              this.tipiArticoliS.getListTipiArticoliTemp(true).subscribe();
            })
            .catch((error: HttpErrorResponse) => {
              //throw 'Deletion failed'
              console.log(error.error.title);
              throw error.error.title;
            })
        );
      },
      update: (key, values) => {
        return firstValueFrom(this.tipiArticoliS.update(key, values))
          .then(() => {
            this.tipiArticoliS.getListTipiArticoliTemp(true).subscribe();
          })
          .catch(() => {
            throw 'Update failed';
          });
      },
    });
  }

  onUpdating(e: any) {
    // e.cancel = new Promise((resolve, reject) => {
    //   resolve('');
    // });
    for (const k in e.oldData) {
      if (e.newData[k] == undefined) {
        e.newData[k] = e.oldData[k];
      }
    }
  }

  onBtnFuncPropClick(selTip: any) {
    this.tipologiaSelezionata = selTip;
    this.popupProprietaTipologiaVisible = true;
  }

  onPopupProprietaTipologiaEvent(e: any) {
    console.log('onPopupProprietaTipologiaEvent');
    this.tipologiaSelezionata = null;
    this.popupProprietaTipologiaVisible = false;
    if (e != null) {
      //do nothing
    }
  }

  onExporting(e: any){
    GridExportExcel(e, 'Tipi Articoli', 'Tipi_Articoli.xlsx');
  }
}
